import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Projects() {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="projects-page">
      <section className="hm-container pt-40 pb-24 md:pb-28">
        <p className="hm-eyebrow mb-8">Projects</p>
        <h1 className="font-display leading-[0.98] tracking-[-0.02em] max-w-5xl" style={{ fontSize: "clamp(44px, 6.4vw, 92px)", fontWeight: 400 }}>
          Current and forthcoming work.
        </h1>
        <p className="mt-10 text-[color:var(--hm-ink-dim)] text-[17px] max-w-2xl leading-relaxed">
          Each project below is a specific building in a specific place.
        </p>
      </section>

      <section className="hm-container pb-36">
        <div className="grid md:grid-cols-12 gap-10">
          {projects.map((p, idx) => (
            <Link
              key={p.id}
              to={p.detail_url || "#"}
              className="md:col-span-8 hm-card overflow-hidden group"
              data-testid={`project-card-${idx}`}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
              </div>
              <div className="p-8 md:p-11">
                <p className="hm-eyebrow mb-4">{p.location}</p>
                <h2 className="font-display leading-[1.02] mb-4" style={{ fontSize: "clamp(30px, 3.6vw, 52px)", fontWeight: 400 }}>{p.title}</h2>
                <p className="text-[color:var(--hm-ink-dim)] text-[16px] max-w-2xl leading-relaxed">{p.summary}</p>
                <div className="mt-7 flex items-center gap-4 flex-wrap">
                  <span className="text-[11px] uppercase tracking-[0.24em] px-3.5 py-1.5 border border-[color:var(--hm-pink)] text-[color:var(--hm-pink)] rounded-full">
                    {p.status}
                  </span>
                  <span className="hm-eyebrow group-hover:text-[color:var(--hm-pink)] transition-colors">View project →</span>
                </div>
              </div>
            </Link>
          ))}

          <div className="md:col-span-4 border border-dashed border-[color:var(--hm-line)] p-10 flex flex-col justify-between min-h-[420px]">
            <div>
              <p className="hm-eyebrow mb-5">Forthcoming</p>
              <h3 className="font-display leading-[1.05]" style={{ fontSize: "28px", fontWeight: 400 }}>More projects in the pipeline.</h3>
            </div>
            <p className="text-[color:var(--hm-ink-dim)] text-[15px] leading-relaxed">
              We publish projects when they are real and consented. If you are a building owner, partner, or investor with something to share, write to us.
            </p>
            <Link to="/contact" className="hm-link mt-6" data-testid="projects-contact-link">Send an enquiry →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
